(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["as-fitment-bar"]) return;
  try {
    
  /* Vehicle context: one writer (this section), many readers (every context
     bar, context note and the product hero). Selecting a vehicle never
     resolves anything here. */
  (function () {
    'use strict';

    var STORAGE_KEY = 'alpine_siege_vehicle';

    function normalize(selection) {
      if (!selection || typeof selection !== 'object') return null;
      var year = typeof selection.year === 'string' || typeof selection.year === 'number' ? String(selection.year).trim() : '';
      var make = typeof selection.make === 'string' ? selection.make.trim() : '';
      var model = typeof selection.model === 'string' ? selection.model.trim() : '';
      if (!year || !make || !model) return null;
      return { year: year, make: make, model: model };
    }

    function readStorage() {
      try {
        var raw = window.localStorage.getItem(STORAGE_KEY);
        return raw ? normalize(JSON.parse(raw)) : null;
      } catch (error) {
        return null;
      }
    }

    function writeStorage(selection) {
      try {
        if (selection) window.localStorage.setItem(STORAGE_KEY, JSON.stringify(selection));
        else window.localStorage.removeItem(STORAGE_KEY);
      } catch (error) {
        /* Storage is a convenience only; in-page context still applies. */
      }
    }

    function describe(selection) {
      var s = normalize(selection);
      return s ? [s.year, s.make, s.model].join(' ') : '';
    }

    var currentSelection = readStorage();
    var dialog = document.querySelector('[data-as-vehicle-dialog]');
    var opener = null;
    var dialogListeners = null;

    /* ---- Context bars and notes ------------------------------------------ */

    function sync(bar) {
      var gate = bar.querySelector('[data-as-fitment-bar-gate]');
      var value = bar.querySelector('[data-as-fitment-bar-value]');
      var action = bar.querySelector('[data-as-fitment-bar-action]');
      if (!value.dataset.asEmpty) value.dataset.asEmpty = value.textContent;
      var text = describe(currentSelection);
      value.textContent = text || value.dataset.asEmpty;
      gate.classList.toggle('as-gate--empty', !text);
      if (action) {
        action.hidden = !dialog;
        action.textContent = text ? action.dataset.asChangeLabel : action.dataset.asSelectLabel;
      }
    }

    function syncNote(note) {
      var head = note.querySelector('[data-as-context-head]');
      var body = note.querySelector('[data-as-context-body]');
      var text = describe(currentSelection);
      if (head) head.textContent = text ? head.dataset.asSetHead : head.dataset.asEmptyHead;
      if (body) body.textContent = text ? (body.dataset.asSetPrefix || '') + text + (body.dataset.asSetSuffix || '') : body.dataset.asEmptyBody;
      note.classList.toggle('as-context-note--set', Boolean(text));
    }

    function init() {
      bindDialog();
      document.querySelectorAll('[data-as-fitment-bar]').forEach(sync);
      document.querySelectorAll('[data-as-fitment-context]').forEach(syncNote);
    }

    /* ---- Selector universe: editorial choices, never conclusions ---------- */

    function universe() {
      if (!dialog) return [];
      try {
        var entries = JSON.parse(dialog.querySelector('[data-as-vehicle-universe]').textContent || '[]');
        return entries.filter(function (e) {
          var start = Number(e.year_start);
          var end = e.year_end === null || e.year_end === undefined || e.year_end === '' ? start : Number(e.year_end);
          return e && typeof e.make === 'string' && typeof e.model === 'string' && Number.isInteger(start) && Number.isInteger(end) && start >= 1000 && end <= 9999 && start <= end;
        }).map(function (e) {
          var start = Number(e.year_start);
          return { make: e.make, model: e.model, start: start, end: e.year_end === null || e.year_end === undefined || e.year_end === '' ? start : Number(e.year_end) };
        });
      } catch (error) {
        return [];
      }
    }

    function covers(entry, year) {
      return entry.start <= year && year <= entry.end;
    }

    function yearOptions(entries) {
      var years = {};
      entries.forEach(function (e) { for (var y = e.start; y <= e.end; y += 1) years[y] = true; });
      return Object.keys(years).map(Number).sort(function (a, b) { return b - a; }).map(String);
    }

    function makeOptions(entries, year) {
      var out = [];
      entries.forEach(function (e) { if (covers(e, Number(year)) && out.indexOf(e.make) < 0) out.push(e.make); });
      return out;
    }

    function modelOptions(entries, year, make) {
      var out = [];
      entries.forEach(function (e) { if (covers(e, Number(year)) && e.make === make && out.indexOf(e.model) < 0) out.push(e.model); });
      return out;
    }

    function fill(select, options, placeholder, value) {
      select.innerHTML = '';
      var first = document.createElement('option');
      first.value = '';
      first.textContent = placeholder;
      select.append(first);
      options.forEach(function (option) {
        var item = document.createElement('option');
        item.value = option;
        item.textContent = option;
        select.append(item);
      });
      select.disabled = options.length === 0;
      select.value = value && options.indexOf(value) > -1 ? value : '';
    }

    function cascade(keep) {
      var entries = universe();
      var year = dialog.querySelector('[data-as-vehicle-year]');
      var make = dialog.querySelector('[data-as-vehicle-make]');
      var model = dialog.querySelector('[data-as-vehicle-model]');
      var wanted = keep || {};
      fill(year, yearOptions(entries), 'Select year', keep ? wanted.year : year.value);
      var makes = year.value ? makeOptions(entries, year.value) : [];
      fill(make, makes, year.value ? 'Select make' : 'Select year first', keep ? wanted.make : make.value);
      var models = year.value && make.value ? modelOptions(entries, year.value, make.value) : [];
      fill(model, models, make.value ? 'Select model' : 'Select make first', keep ? wanted.model : model.value);
    }

    /* ---- Dialog: native semantics first, a small fallback where needed --- */

    var supportsModal = Boolean(dialog && typeof dialog.showModal === 'function');

    function focusables() {
      return Array.prototype.filter.call(dialog.querySelectorAll('select, button, [href], input, [tabindex]:not([tabindex="-1"])'), function (el) {
        return !el.disabled && !el.hidden;
      });
    }

    function open(button) {
      bindDialog();
      if (!dialog) return;
      opener = button || document.activeElement;
      openerModule = opener && opener.closest ? opener.closest('[data-as-fitment]') : null;
      dialog.querySelector('[data-as-vehicle-error]').hidden = true;
      cascade(currentSelection || {});
      if (supportsModal) {
        try { dialog.showModal(); } catch (error) { dialog.setAttribute('open', ''); }
      } else {
        dialog.setAttribute('open', '');
      }
      dialog.querySelector('[data-as-vehicle-year]').focus();
    }

    /* Focus returns to the opener. If the opener was replaced by the module
       it lives in (the product page swaps its prompt for the outcome), the
       module's Change control takes the focus instead. */
    var openerModule = null;

    function restoreFocus() {
      var target = opener;
      if (target && (!target.isConnected || target.hidden || target.closest('[hidden]'))) {
        target = openerModule && openerModule.isConnected ? openerModule.querySelector('[data-as-fitment-change]') : null;
      }
      if (target && target.isConnected && !target.hidden && !target.closest('[hidden]') && typeof target.focus === 'function') target.focus();
      opener = null;
      openerModule = null;
    }

    function close() {
      if (!dialog) return;
      if (supportsModal && dialog.open) {
        try { dialog.close(); } catch (error) { dialog.removeAttribute('open'); }
      } else {
        dialog.removeAttribute('open');
      }
      restoreFocus();
    }

    function commit() {
      var year = dialog.querySelector('[data-as-vehicle-year]').value;
      var make = dialog.querySelector('[data-as-vehicle-make]').value;
      var model = dialog.querySelector('[data-as-vehicle-model]').value;
      var selection = normalize({ year: year, make: make, model: model });
      if (!selection) {
        var error = dialog.querySelector('[data-as-vehicle-error]');
        error.hidden = false;
        var missing = !year ? '[data-as-vehicle-year]' : !make ? '[data-as-vehicle-make]' : '[data-as-vehicle-model]';
        dialog.querySelector(missing).focus();
        return;
      }
      /* Persist only once all three values are complete. */
      currentSelection = selection;
      writeStorage(selection);
      init();
      document.dispatchEvent(new CustomEvent('as:fitment-changed', { detail: { selection: selection } }));
      close();
    }

    function releaseDialog() {
      if (dialogListeners) dialogListeners.abort();
      dialogListeners = null;
      if (dialog && dialog.open) close();
      dialog = null;
      supportsModal = false;
    }

    function bindDialog() {
      var next = document.querySelector('[data-as-vehicle-dialog]');
      if (next !== dialog) {
        releaseDialog();
        dialog = next;
        supportsModal = Boolean(dialog && typeof dialog.showModal === 'function');
      }
      if (!dialog || dialogListeners) return;
      /* Listener ownership follows the element, never a cloneable DOM flag. */
      dialogListeners = new AbortController();
      function listen(element, type, handler) {
        element.addEventListener(type, handler, { signal: dialogListeners.signal });
      }
      listen(dialog.querySelector('[data-as-vehicle-form]'), 'submit', function (event) {
        event.preventDefault();
        commit();
      });
      listen(dialog.querySelector('[data-as-vehicle-cancel]'), 'click', close);
      listen(dialog.querySelector('[data-as-vehicle-year]'), 'change', function () { cascade(); });
      listen(dialog.querySelector('[data-as-vehicle-make]'), 'change', function () { cascade(); });
      /* Native Escape fires cancel; the fallback handles Escape and a focus loop. */
      listen(dialog, 'cancel', function (event) {
        event.preventDefault();
        close();
      });
      listen(dialog, 'keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          close();
          return;
        }
        /* Native modal dialogs make the page inert but still let Tab leave to
           browser chrome; wrapping keeps the loop inside the selector. */
        if (event.key !== 'Tab') return;
        var items = focusables();
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
      /* Click on the scrim (the dialog element itself, outside the form) closes. */
      listen(dialog, 'click', function (event) {
        if (event.target === dialog) close();
      });
    }

    document.addEventListener('click', function (event) {
      var action = event.target.closest('[data-as-fitment-bar-action], [data-as-open-selector]');
      if (!action || action.hidden || event.defaultPrevented) return;
      event.preventDefault();
      open(action);
    });

    document.addEventListener('as:vehicle-open', function (event) {
      open(event.detail && event.detail.opener);
    });

    window.addEventListener('storage', function (event) {
      if (event.key === STORAGE_KEY || event.key === null) {
        currentSelection = readStorage();
        init();
      }
    });
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        currentSelection = readStorage();
        init();
      }
    });
    document.addEventListener('as:fitment-changed', function (event) {
      currentSelection = event.detail && Object.hasOwn(event.detail, 'selection') ? normalize(event.detail.selection) : readStorage();
      init();
    });
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', init);
    document.addEventListener('shopify:block:deselect', init);
    document.addEventListener('shopify:section:reorder', init);
    document.addEventListener('shopify:section:unload', function (event) {
      if (dialog && event.target.contains(dialog)) {
        releaseDialog();
        document.querySelectorAll('[data-as-fitment-bar]').forEach(sync);
      }
      window.setTimeout(init, 0);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["as-header"]) return;
  try {
    
  // Conveniences the <details> element does not provide on its own: close on
  // Escape, and close when the pointer goes elsewhere. Everything else --
  // toggling, keyboard activation, the expanded state -- is native.
  (function () {
    'use strict';
    var dismissedShopRegion = null;

    function closeAll(except) {
      document.querySelectorAll('[data-as-disclosure][open]').forEach(function (el) {
        if (el !== except && !el.contains(except)) el.removeAttribute('open');
      });
    }

    document.addEventListener('click', function (event) {
      var open = document.querySelector('[data-as-disclosure][open]');
      if (!open) return;
      if (!open.contains(event.target)) closeAll(null);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var open = document.querySelector('[data-as-disclosure][open]');
      if (!open) return;
      dismissedShopRegion = open.closest('[data-as-shop-region]');
      closeAll(null);
      var summary = open.querySelector('summary');
      if (summary) summary.focus();
    });

    document.addEventListener('pointerover', function (event) {
      var region = event.target.closest('[data-as-shop-region]');
      if (!region || region.contains(event.relatedTarget) || !window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
      if (region === dismissedShopRegion) return;
      var details = region.querySelector('details');
      closeAll(details); details.open = true;
    });
    document.addEventListener('pointerout', function (event) {
      var region = event.target.closest('[data-as-shop-region]');
      if (!region || region.contains(event.relatedTarget)) return;
      if (region === dismissedShopRegion) dismissedShopRegion = null;
      if (region.contains(document.activeElement)) return;
      region.querySelector('details').open = false;
    });
    document.addEventListener('focusout', function (event) {
      var region = event.target.closest('[data-as-shop-region]');
      if (region && !region.contains(event.relatedTarget)) region.querySelector('details').open = false;
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowDown') return;
      var region = event.target.closest('[data-as-shop-region]');
      if (!region || event.target.closest('.as-header__dropdown')) return;
      event.preventDefault();
      var details = region.querySelector('details'); closeAll(details); details.open = true;
      var first = details.querySelector('a'); if (first) first.focus();
    });

    document.addEventListener('toggle', function (event) {
      var el = event.target;
      if (!el.hasAttribute || !el.hasAttribute('data-as-disclosure')) return;
      if (el.open) closeAll(el);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["as-product-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  function syncVariant(select) {
    const section = select.closest('.as-product-hero');
    const option = select.options[select.selectedIndex];
    const available = Boolean(option && !option.disabled && option.value);
    const button = select.form.querySelector('[data-as-add-to-cart]');
    button.disabled = !available;
    button.querySelector('span').textContent = available ? button.dataset.asAddLabel : button.dataset.asUnavailableLabel;
    section.querySelector('[data-as-current-price]').textContent = option?.dataset.asPrice || '';
    const comparePrice = section.querySelector('[data-as-compare-price]');
    comparePrice.textContent = option?.dataset.asComparePrice || '';
    comparePrice.classList.toggle('as-commerce__compare-price--hidden', !comparePrice.textContent);
    // Availability is real Shopify variant state. Only "Not available" is
    // ever written; an available variant clears the line and the enabled
    // native button carries the state.
    const availability = section.querySelector('[data-as-availability]');
    if (availability) {
      availability.textContent = available ? '' : availability.dataset.asUnavailableLabel;
      availability.closest('[data-as-availability-row]').classList.toggle('as-commerce__availability--hidden', available);
    }
    return available;
  }

  function init(scope) {
    scope.querySelectorAll('.as-product-form__select').forEach(syncVariant);
  }

  document.addEventListener('change', (event) => {
    if (!event.target.matches('.as-product-form__select')) return;
    syncVariant(event.target);
    const url = new URL(window.location.href);
    if (event.target.value) url.searchParams.set('variant', event.target.value);
    else url.searchParams.delete('variant');
    window.history.replaceState({}, '', url);
  });

  document.addEventListener('submit', (event) => {
    if (!event.target.matches('.as-product-form')) return;
    const select = event.target.querySelector('.as-product-form__select');
    if (select && (!select.options[select.selectedIndex] || select.options[select.selectedIndex].disabled || !select.value)) {
      syncVariant(select);
      event.preventDefault();
    }
  });

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  window.addEventListener('pageshow', () => init(document));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
})();

/* FitmentGate. A presentation layer over the product's application records.
   `resolve` is a pure function of the stored record strings and the
   customer's vehicle context (Year, Make, Model from the global selector).
   It fails closed: an outcome requires an explicit record whose make and
   model equal the selection exactly and whose own year range contains the
   selected year; each applicable record renders its own status with its
   configuration as a qualifier, so nothing generalises to every vehicle of
   that year. Absent applicable records yield "Not assessed / no data";
   incomplete or overlapping records remain neutral. It never touches the
   product form, and it never writes storage: the vehicle context section
   is the only writer.

   VEHICLE CONTEXT OPTIONS != COMPATIBILITY CONCLUSIONS. */
(() => {
  const STORAGE_KEY = 'alpine_siege_vehicle';
  const CANONICAL = {
    'Validated': 'validated',
    'Validation in progress': 'in-progress',
    'Not yet validated': 'not-yet-validated',
    'Not applicable': 'not-applicable'
  };

  function modelYear(value) {
    if (!['string', 'number'].includes(typeof value) || String(value).trim() === '') return null;
    const year = Number(value);
    return Number.isInteger(year) && year >= 1000 && year <= 9999 ? year : null;
  }

  function yearRange(record) {
    const start = modelYear(record.year_start);
    const end = record.year_end === null || record.year_end === undefined || record.year_end === '' ? start : modelYear(record.year_end);
    return start !== null && end !== null && start <= end ? { start, end } : null;
  }

  function normalize(selection) {
    if (!selection || typeof selection !== 'object') return null;
    const year = ['string', 'number'].includes(typeof selection.year) ? String(selection.year).trim() : '';
    const make = typeof selection.make === 'string' ? selection.make.trim() : '';
    const model = typeof selection.model === 'string' ? selection.model.trim() : '';
    return year && make && model ? { year, make, model } : null;
  }

  function classify(record) {
    const status = record.validation_status;
    if (typeof record.configuration !== 'string' || record.configuration.trim() === '') return { outcome: 'incomplete', record };
    if (typeof status !== 'string' || status.trim() === '') return { outcome: 'incomplete', record };
    return { outcome: Object.hasOwn(CANONICAL, status) ? CANONICAL[status] : 'literal', status, record };
  }

  function resolve(records, selection) {
    const s = normalize(selection);
    if (!s) return { outcome: 'unset' };
    const year = modelYear(s.year);
    if (year === null) return { outcome: 'unset' };
    if (!Array.isArray(records)) return { outcome: 'incomplete' };
    const candidates = records.filter((r) => r && r.make === s.make && r.model === s.model);
    if (candidates.some((r) => !yearRange(r))) return { outcome: 'incomplete' };
    const inYear = candidates.filter((r) => { const range = yearRange(r); return range.start <= year && year <= range.end; });
    if (!inYear.length) return { outcome: 'not-assessed', selection: s, matches: [] };
    /* One outcome per recorded configuration. The qualifier travels with it. */
    const groups = new Map();
    inYear.forEach((r) => {
      const qualifier = typeof r.configuration === 'string' ? r.configuration.trim() : '';
      if (!groups.has(qualifier)) groups.set(qualifier, []);
      groups.get(qualifier).push(r);
    });
    const matches = [...groups].map(([qualifier, group]) => {
      if (group.length > 1) return { outcome: 'ambiguous', qualifier, records: group };
      return { ...classify(group[0]), qualifier };
    });
    const first = matches[0];
    if (matches.length === 1) return { outcome: first.outcome, status: first.status, record: first.record, qualifier: first.qualifier, matches, selection: s };
    return { outcome: 'records', matches, selection: s };
  }

  function readStorage() {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? normalize(JSON.parse(raw)) : null;
    } catch (error) {
      return null;
    }
  }

  let currentSelection = readStorage();

  function describe(selection) {
    const s = normalize(selection);
    return s ? [s.year, s.make, s.model].join(' ') : '';
  }

  function line(className, text) {
    const p = document.createElement('p');
    p.className = className;
    p.textContent = text;
    return p;
  }

  function renderMatch(gate, match, selection) {
    const template = gate.querySelector('[data-as-fitment-template="' + match.outcome + '"]');
    const fragment = template.content.cloneNode(true);
    const block = fragment.querySelector('.as-validation');
    if (match.outcome === 'literal') fragment.querySelector('.as-validation__label').textContent = match.status;
    block.append(line('as-validation__vehicle', describe(selection)));
    if (match.qualifier) block.append(line('as-validation__qualifier', match.qualifier));
    if (match.record && typeof match.record.note === 'string' && match.record.note) block.append(line('as-validation__note', match.record.note));
    return fragment;
  }

  function present(gate, selection) {
    const records = JSON.parse(gate.querySelector('[data-as-fitment-records]').textContent || '[]');
    const result = gate.querySelector('[data-as-fitment-result]');
    const set = gate.querySelector('[data-as-fitment-set]');
    const resolved = resolve(records, selection);
    result.innerHTML = '';
    if (resolved.outcome === 'unset') {
      const prompt = line('as-fitment__prompt', 'No vehicle selected. Recorded applications are listed in the compatibility table.');
      prompt.setAttribute('data-as-fitment-prompt', '');
      const actions = document.createElement('div');
      actions.className = 'as-fitment__actions';
      const select = document.createElement('button');
      select.type = 'button';
      select.className = 'as-button as-button--secondary';
      select.setAttribute('data-as-fitment-select', '');
      select.setAttribute('data-as-open-selector', '');
      select.setAttribute('aria-haspopup', 'dialog');
      select.textContent = 'Select your vehicle';
      actions.append(select);
      result.append(prompt, actions);
      set.hidden = true;
      gate.removeAttribute('data-as-fitment-outcome');
      return resolved;
    }
    if (resolved.outcome === 'not-assessed' || resolved.outcome === 'incomplete') {
      result.append(renderMatch(gate, { outcome: resolved.outcome, qualifier: '' }, resolved.selection || selection));
    } else {
      resolved.matches.forEach((match) => result.append(renderMatch(gate, match, resolved.selection)));
    }
    const selectionLine = gate.querySelector('[data-as-fitment-selection]');
    selectionLine.textContent = describe(resolved.selection || selection);
    set.hidden = false;
    gate.setAttribute('data-as-fitment-outcome', resolved.outcome);
    return resolved;
  }

  function openSelector(button) {
    document.dispatchEvent(new CustomEvent('as:vehicle-open', { detail: { opener: button } }));
  }

  function initGate(gate) {
    if (gate.dataset.asFitmentReady) return;
    gate.dataset.asFitmentReady = 'true';
    gate.addEventListener('click', (event) => {
      const button = event.target.closest('[data-as-fitment-change], [data-as-fitment-select]');
      if (button) {
        event.preventDefault();
        openSelector(button);
      }
    });
    present(gate, currentSelection);
  }

  function init(scope) {
    scope.querySelectorAll('[data-as-fitment]').forEach(initGate);
  }

  window.AlpineSiegeFitment = { resolve };
  function refreshContext() {
    currentSelection = readStorage();
    document.querySelectorAll('[data-as-fitment]').forEach((gate) => present(gate, currentSelection));
  }
  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY || event.key === null) refreshContext();
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refreshContext();
  });
  document.addEventListener('as:fitment-changed', (event) => {
    currentSelection = event.detail && Object.hasOwn(event.detail, 'selection') ? normalize(event.detail.selection) : readStorage();
    document.querySelectorAll('[data-as-fitment]').forEach((gate) => present(gate, currentSelection));
  });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
